module.exports = __webpack_public_path__ + "static/media/tuihuodan641.7b678ecc.png";